__turbopack_context__.v({
  "chevronIcon": "MountedStorageTypeSelect-module__4nAgJG__chevronIcon",
  "container": "MountedStorageTypeSelect-module__4nAgJG__container",
  "fullSize": "MountedStorageTypeSelect-module__4nAgJG__fullSize",
});
